/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseStatusType } from './CaseStatusType';
import {
    CaseStatusTypeFromJSON,
    CaseStatusTypeFromJSONTyped,
    CaseStatusTypeToJSON,
    CaseStatusTypeToJSONTyped,
} from './CaseStatusType';

/**
 * 
 * @export
 * @interface CaseStatusTime
 */
export interface CaseStatusTime {
    /**
     * 
     * @type {CaseStatusType}
     * @memberof CaseStatusTime
     */
    status?: CaseStatusType;
    /**
     * 
     * @type {Date}
     * @memberof CaseStatusTime
     */
    date?: Date;
}



/**
 * Check if a given object implements the CaseStatusTime interface.
 */
export function instanceOfCaseStatusTime(value: object): value is CaseStatusTime {
    return true;
}

export function CaseStatusTimeFromJSON(json: any): CaseStatusTime {
    return CaseStatusTimeFromJSONTyped(json, false);
}

export function CaseStatusTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseStatusTime {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : CaseStatusTypeFromJSON(json['status']),
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

export function CaseStatusTimeToJSON(json: any): CaseStatusTime {
    return CaseStatusTimeToJSONTyped(json, false);
}

export function CaseStatusTimeToJSONTyped(value?: CaseStatusTime | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': CaseStatusTypeToJSON(value['status']),
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
    };
}

